import React, { useEffect, useState } from 'react';
import { recruiterAPI } from '@/services/api';
import { BarChart3, Briefcase, Users, TrendingUp } from 'lucide-react';

export default function RecruiterAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => { recruiterAPI.getAnalytics().then(setData).catch(() => { /* noop */ }); }, []);

  if (!data) return <p className="text-slate-500 dark:text-zinc-500">Loading analytics...</p>;

  return (
    <div data-testid="recruiter-analytics">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white mb-1">Analytics</h1>
      <p className="text-slate-500 dark:text-zinc-500 text-sm mb-6">Your recruitment metrics</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {[['Total Jobs', data.total_jobs, 'blue'], ['Active', data.active_jobs, 'emerald'], ['Closed', data.closed_jobs, 'zinc'], ['Matches', data.total_matches, 'purple']].map(([l, v, c]) => (
          <div key={l} className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800/50 rounded-lg p-4 text-center">
            <p className="text-slate-500 dark:text-zinc-500 text-xs mb-1">{l}</p>
            <p className="text-slate-900 dark:text-white text-2xl font-bold">{v}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <div className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800/50 rounded-lg p-5">
          <h3 className="text-slate-900 dark:text-white font-medium mb-3">Screening & Selection</h3>
          <div className="space-y-2">
            <div className="flex justify-between text-sm"><span className="text-slate-500 dark:text-zinc-500">Screenings Completed</span><span className="text-slate-900 dark:text-white">{data.screening_completed}</span></div>
            <div className="flex justify-between text-sm"><span className="text-slate-500 dark:text-zinc-500">Candidates Selected</span><span className="text-emerald-600 dark:text-emerald-400">{data.selected_candidates}</span></div>
          </div>
        </div>
        <div className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800/50 rounded-lg p-5">
          <h3 className="text-slate-900 dark:text-white font-medium mb-3">Access Requests</h3>
          <div className="space-y-2">
            <div className="flex justify-between text-sm"><span className="text-slate-500 dark:text-zinc-500">Pending</span><span className="text-amber-600 dark:text-amber-400">{data.pending_requests}</span></div>
            <div className="flex justify-between text-sm"><span className="text-slate-500 dark:text-zinc-500">Approved</span><span className="text-emerald-600 dark:text-emerald-400">{data.approved_requests}</span></div>
          </div>
        </div>
      </div>
      {Object.keys(data.job_types || {}).length > 0 && (
        <div className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800/50 rounded-lg p-5">
          <h3 className="text-slate-900 dark:text-white font-medium mb-3">Job Type Breakdown</h3>
          <div className="space-y-2">
            {Object.entries(data.job_types).map(([type, count]) => (
              <div key={type} className="flex items-center gap-3">
                <div className="flex-1">
                  <div className="flex justify-between text-sm mb-1"><span className="text-slate-500 dark:text-zinc-400 capitalize">{type}</span><span className="text-slate-600 dark:text-zinc-300">{count}</span></div>
                  <div className="h-1.5 bg-slate-100 dark:bg-zinc-800 rounded-full overflow-hidden"><div className="h-full bg-emerald-500 rounded-full" style={{ width: `${(count / data.total_jobs) * 100}%` }} /></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
